import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Form from "../comman/form";
import http from "../services/HttpService";
import auth from "../services/authService";
import config from "../config.json";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { getAlert } from "../services/appAlerts";

class ChangePassword extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
    };
  }

  schema = {
    oldPassword: Joi.string().label("Existing Password"),
    newPassword: Joi.string().label("New Password"),
    confirmPassword: Joi.any()
      .valid(Joi.ref("newPassword"))
      .required()
      .options({ language: { any: { allowOnly: "must match new password" } } })
      .label("Confirm Password"),
  };

  doSubmit = async () => {
    const { data, errors } = this.state;
    const user = auth.getCurrentUser();
    try {
      const passResult = this.password_validate(data["newPassword"]);
      //console.log(passResult);
      if (passResult) {
        data["userId"] = user?.id;
        const { data: result } = await http.post(config.ChangePassword, data);
        //console.log(result);
        getAlert("", "Password Changed Successfully", "success");
        //auth.logout();
        //window.location.href = "/Login";
      } else {
        getAlert(
          "Password Strength",
          "Please enter strong password",
          "error"
        );
      }
    } catch (ex) {
      //console.log(ex);
      errors["oldPassword"] = ex?.response?.data?.message;
      this.setState({ errors });
    }
  };

  password_validate(password) {
    var re = {
      capital: /[A-Z]/,
      digit: /[0-9]/,
      except: /[aeiou]/,
      full: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?][A-Za-z0-9]/,
    };
    //console.log("capital", re.capital.test(password));
    //console.log("digit", re.digit.test(password));
    //console.log("except", re.except.test(password));
    //console.log("full", re.full.test(password));
    return (
      re.capital.test(password) &&
      re.digit.test(password) &&
      re.except.test(password) &&
      re.full.test(password)
    );
  }

  componentWillReceiveProps = () => {
    this.setState({ data: {}, errors: {} });
  };

  // getAlert(title, message, type) {
  //   return Swal.fire({
  //     title: title,
  //     text: message,
  //     icon: type,
  //     confirmButtonText: "Close",
  //     confirmButtonColor: "#d33",
  //     onClose: () => {
  //       if (type === "success") {
  //         auth.logout();
  //         window.location = "/Login";
  //       }
  //     },
  //   });
  // }

  render() {
    const { showHide, handleModalShowHide } = this.props;
    return (
      <Modal show={showHide} size="xl">
        <Modal.Header closeButton onHide={handleModalShowHide}>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body className="border">
          <div className="row">
            <div className="col-md-12 form-group">
              <p className="text-red">
                <i className="fa fa-hand-o-right" aria-hidden="true"></i> New
                password should contain at least 8 characters (and up to 50
                characters) with a mixture of both uppercase and lowercase
                letters. A mixture of letters and numbers inclusion of at least
                one special character, e.g., ! @ # ? [no spaces allowed!]
              </p>
            </div>
            <div className="col-md-12">
              {this.renderInput("oldPassword", "Existing Password", "password")}
            </div>
            <div className="col-md-12">
              {this.renderInput("newPassword", "New Password", "password")}
            </div>
            <div className="col-md-12">
              {this.renderInput(
                "confirmPassword",
                "Confirm Password",
                "password"
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <button className="btn btn-sm btn-outline-default" onClick={handleModalShowHide}>
            <i className="fa fa-times"></i> Close
          </button> */}
          <button
            className="btn btn-sm btn-outline-default"
            disabled={this.validate()}
            onClick={this.handleSubmit}
          >
            <i className="fa fa-check"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ChangePassword;
